const t = () => {
  if (typeof window > "u")
    return 0;
  const e = window.getComputedStyle(document.documentElement).getPropertyValue("--safe-area-top").replace("px", "");
  return Number(e) || 0;
}, o = () => typeof window < "u" ? window.scrollY : 0;
export {
  t as getDocumentSafeArea,
  o as getRootScrollY
};
